(() => {
  'use strict';
  const money = cents => new Intl.NumberFormat('en-AU', {style: 'currency', currency: window.Shopify?.currency?.active || 'AUD'}).format(cents / 100);
  const read = node => node ? JSON.parse(node.textContent) : null;
  const routes = read(document.getElementById('commerce-routes')) || {cart: '/cart', cartAdd: '/cart/add'};
  const initialised = new WeakSet();
  const kitJourneyPrefix = 'starshield:kit-journey:';
  const kitJourneyActiveKey = 'starshield:kit-active-token';
  const validJourneyToken = token => /^[a-f0-9-]{16,80}$/i.test(token || '');
  function kitJourney(token) {
    if (!validJourneyToken(token)) return null;
    try {
      const journey = JSON.parse(sessionStorage.getItem(`${kitJourneyPrefix}${token}`));
      if (!journey || journey.version !== 1 || journey.token !== token || !Number.isFinite(journey.createdAt) || Date.now() - journey.createdAt > 43200000) return null;
      const returnUrl = new URL(journey.returnUrl, window.location.origin);
      if (returnUrl.origin !== window.location.origin) return null;
      return {...journey, returnUrl: returnUrl.toString()};
    } catch (_) { return null; }
  }
  function initKitReturnControl(root) {
    const token = new URL(window.location.href).searchParams.get('ss_kit_return');
    const journey = kitJourney(token);
    if (!journey) return;
    const link = document.createElement('a');
    link.className = 'button kit-return-link';
    link.href = journey.returnUrl;
    link.textContent = '← RETURN TO BUILD YOUR KIT';
    link.addEventListener('click', event => {
      event.preventDefault();
      const current = kitJourney(token);
      if (!current) return link.remove();
      const target = new URL(current.returnUrl);
      target.searchParams.set('ss_kit_restore', token);
      window.location.assign(target);
    });
    root.before(link);
  }
  const sameOptions = (left, right) => left.length === right.length && left.every((value, index) => value === right[index]);
  const variantFor = (product, options) => product?.variants.find(variant => sameOptions(variant.options, options));
  const fixedVariant = product => product && (product.hasOnlyDefaultVariant || product.variants.length === 1) ? product.variants[0] : null;
  const quantityAllowed = (variant, quantity) => {
    const rule = variant?.quantityRule || {};
    return Number.isInteger(quantity) && quantity >= (rule.min || 1) && quantity <= Math.min(rule.max || 99, 99) && (quantity - (rule.min || 1)) % (rule.increment || 1) === 0 && !variant?.requiresSellingPlan;
  };
  async function addItems(items) {
    const response = await fetch(`${routes.cartAdd}.js`, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add the selected items. Please try again.');
    window.location.assign(routes.cart);
  }

  function initProduct(root) {
    if (initialised.has(root)) return;
    initialised.add(root);
    const scope = root.closest('.shopify-section') || root.parentElement;
    const $ = id => scope.querySelector(`#${id}`);
    const product = read($('product-data')), approved = read($('approved-product-data'));
    const upsellProducts = read($('upsell-products')) || {};
    initKitReturnControl(root);
    if (!product || !approved) return;
    const photos = [...approved.photos], form = root.querySelector('[data-product-form]'), id = form.querySelector('[data-variant-id]');
    let current = product.variants.find(variant => String(variant.id) === String(product.selectedId)) || product.variants[0];
    let busy = false;
    // Golden Master selectPhoto: image, captions, dialog and thumbnail state stay together.
    function selectPhoto(index) {
      if (!photos[index]) return;
      const alt = `${approved.title} — catalogue photo ${index + 1}`;
      $('large').removeAttribute('srcset'); $('large').removeAttribute('sizes');
      $('large').src = photos[index]; $('large').alt = alt;
      $('caption').textContent = `Catalogue photo ${index + 1} of ${photos.length} · pictured extras may not be included`;
      $('zoom-image').src = photos[index]; $('zoom-image').alt = `${alt}, enlarged`;
      $('zoom-caption').textContent = `Catalogue photo ${index + 1} of ${photos.length}`;
      root.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.photo) === index)));
    }
    const bindPhoto = button => button.addEventListener('click', () => selectPhoto(Number(button.dataset.photo)));
    root.querySelectorAll('[data-photo]').forEach(bindPhoto);
    function variantPhoto(variant) {
      if (!variant) return;
      const native = approved.variantPhotos.find(binding => binding.mediaId && String(binding.mediaId) === String(variant.mediaId));
      if (native) return selectPhoto(native.photo);
      if (variant.mediaUrl) {
        let index = photos.indexOf(variant.mediaUrl);
        if (index < 0) {
          index = photos.push(variant.mediaUrl) - 1;
          const button = document.createElement('button'); button.type = 'button'; button.className = 'thumb'; button.dataset.photo = index;
          button.setAttribute('aria-label', `View ${variant.title} photo`);
          const image = document.createElement('img'); image.src = variant.mediaUrl; image.alt = ''; image.loading = 'lazy';
          button.append(image); bindPhoto(button); root.querySelector('.thumbs').append(button);
        }
        return selectPhoto(index);
      }
      const fallback = approved.variantPhotos.find(binding => sameOptions(binding.options, variant.options));
      if (fallback) selectPhoto(fallback.photo);
    }
    const imageDialog = $('image-dialog');
    $('zoom-trigger').addEventListener('click', () => imageDialog.showModal());
    $('zoom-close').addEventListener('click', () => imageDialog.close());
    imageDialog.addEventListener('click', event => { if (event.target === imageDialog) imageDialog.close(); });
    root.querySelectorAll('[data-option]').forEach(control => {
      const value = current?.options[Number(control.dataset.option)];
      if (control.type === 'radio') control.checked = control.value === value; else control.value = value;
    });
    const extras = [...root.querySelectorAll('[data-upsell-handle]')];
    function upsellVariant(checkbox) {
      const control = checkbox.dataset.upsellControls ? $(checkbox.dataset.upsellControls) : null;
      return variantFor(upsellProducts[checkbox.dataset.upsellHandle], control ? [control.value] : JSON.parse(checkbox.dataset.upsellDefault));
    }
    function syncUpsells() {
      extras.forEach(checkbox => {
        const product = upsellProducts[checkbox.dataset.upsellHandle];
        checkbox.disabled = !product?.variants.some(variant => variant.available && quantityAllowed(variant, 1));
        const control = checkbox.dataset.upsellControls ? $(checkbox.dataset.upsellControls) : null;
        if (control) {
          control.disabled = !checkbox.checked || checkbox.disabled;
          [...control.options].forEach(option => {
            const variant = variantFor(product, [option.value]); option.dataset.approvedLabel ||= option.textContent;
            if (checkbox.dataset.upsellPriceDisplay) option.textContent = `${option.dataset.approvedLabel} · ${variant ? money(variant.price) : 'Unavailable'}`;
          });
        }
        const variant = upsellVariant(checkbox);
        checkbox.closest('.upsell-item').querySelector('.upsell-price').textContent = variant ? `${money(variant.price)}${variant.available ? '' : ' · Sold out'}` : 'Unavailable';
      });
    }
    function update(changePhoto = false) {
      const optionCount = product.variants[0]?.options.length || 0;
      const selected = Array.from({length: optionCount}, (_, index) => (root.querySelector(`select[data-option="${index}"]`) || root.querySelector(`input[data-option="${index}"]:checked`))?.value || (product.hasOnlyDefaultVariant ? product.variants[0].options[index] : ''));
      current = variantFor(product, selected) || null;
      id.value = current?.id || ''; id.disabled = !current?.available;
      const quantity = Number($('quantity').value), validQuantity = !!current && quantityAllowed(current, quantity);
      const selectedExtras = extras.filter(checkbox => checkbox.checked), extraVariants = selectedExtras.map(upsellVariant);
      const extrasAvailable = selectedExtras.every((checkbox, index) => !checkbox.disabled && extraVariants[index]?.available && quantityAllowed(extraVariants[index], 1));
      const total = current && validQuantity ? current.price * quantity + extraVariants.reduce((sum, variant) => sum + (variant?.price || 0), 0) : 0;
      $('price').textContent = current ? money(current.price) : 'Unavailable combination';
      const compareAt = $('compare-at');
      if (compareAt) { compareAt.hidden = !current || !(current.compareAtPrice > current.price); compareAt.textContent = compareAt.hidden ? '' : money(current.compareAtPrice); }
      $('availability').textContent = current ? (current.available ? 'Available' : 'Sold out') : 'This combination is unavailable';
      $('buy').disabled = busy || !current?.available || !validQuantity || !extrasAvailable;
      $('buy').textContent = busy ? 'Adding…' : !current?.available ? 'Unavailable' : !validQuantity ? 'Check quantity' : !extrasAvailable ? 'Selected accessory unavailable' : `Add ${selectedExtras.length ? `${1 + selectedExtras.length} items to cart` : 'to cart'} · ${money(total)}`;
      $('mobile-label').textContent = (current?.title === 'Default Title' ? approved.title : current?.title || 'Choose options') + (current ? ` · ${money(current.price)}` : '');
      if (changePhoto && current) {
        variantPhoto(current);
        const url = new URL(window.location.href); url.searchParams.set('variant', current.id); window.history.replaceState({}, '', url);
      }
    }
    root.querySelectorAll('[data-option]').forEach(control => control.addEventListener('change', () => { $('status').textContent = ''; update(true); }));
    extras.forEach(control => control.addEventListener('change', () => { syncUpsells(); $('status').textContent = ''; update(); }));
    root.querySelectorAll('[data-upsell-option]').forEach(control => control.addEventListener('change', () => { syncUpsells(); $('status').textContent = ''; update(); }));
    $('quantity').addEventListener('input', () => update());
    form.addEventListener('submit', async event => {
      event.preventDefault(); update(); if (busy || $('buy').disabled) return;
      const items = [{id: current.id, quantity: Number($('quantity').value)}, ...extras.filter(checkbox => checkbox.checked).map(checkbox => ({id: upsellVariant(checkbox).id, quantity: 1}))];
      busy = true; update(); $('status').textContent = 'Adding your selection…';
      try { await addItems(items); } catch (error) { $('status').textContent = error.message; busy = false; update(); }
    });
    $('mobile-button').addEventListener('click', () => {
      $('buyblock').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); $('quantity').focus({preventScroll: true});
    });
    const syncMobileBuy = () => $('mobile-buy').classList.toggle('show', $('buyblock').getBoundingClientRect().bottom <= 0);
    new IntersectionObserver(syncMobileBuy).observe($('buyblock'));
    // A fast scroll can jump from below to above the viewport without crossing an observer threshold.
    let mobileFrame = false;
    window.addEventListener('scroll', () => {
      if (mobileFrame) return;
      mobileFrame = true;
      requestAnimationFrame(() => { mobileFrame = false; syncMobileBuy(); });
    }, {passive: true});
    window.addEventListener('resize', syncMobileBuy);
    selectPhoto(0); syncUpsells(); update(true);
  }

  function initKit(node) {
    if (initialised.has(node)) return;
    initialised.add(node);
    const scope = node.closest('.shopify-section') || node.parentElement, $ = id => scope.querySelector(`#${id}`);
    const kits = read(node), products = read($('kit-products')), initialKit = read($('kit-initial'));
    const selections = {}, carouselIndexes = {};
    let busy = false, selectedLines = [];
    const handles = {
      mount: 'starlink-mini-mount', budget: 'budget-starlink-mini-mount-magnetic-base-with-quick-release',
      cover: 'protective-polycarbonate-cover', victron: 'starshield-premium-starlink-mini-dc-power-supply-victron',
      dc: 'original-starlink-mini-dc-power-cable', switch: 'starshield-12v-power-switch-kit', holders: 'magnetic-cable-holders',
      anderson: 'starlink-mini-to-anderson-cable', vehicle: 'car-charger-for-starlink-mini', tether: 'security-tether'
    };
    const restoreToken = new URL(window.location.href).searchParams.get('ss_kit_restore');
    const restoreJourney = kitJourney(restoreToken);
    let restoredKit = null, restoredScroll = null;
    if (restoreJourney) {
      const target = new URL(restoreJourney.returnUrl);
      const here = new URL(window.location.href);
      const sameBuilder = target.pathname === here.pathname && target.searchParams.get('view') === here.searchParams.get('view');
      if (sameBuilder && kits[restoreJourney.activeKit]) {
        restoredKit = restoreJourney.activeKit;
        restoredScroll = Number.isFinite(restoreJourney.scrollY) ? restoreJourney.scrollY : null;
        for (const [key, values] of Object.entries(restoreJourney.selections || {})) if (kits[key] && values && typeof values === 'object') selections[key] = {...values};
        for (const [key, value] of Object.entries(restoreJourney.carouselIndexes || {})) if (kits[key] && Number.isInteger(value)) carouselIndexes[key] = value;
      }
    }

    const optionValues = (key, index) => [...new Set((products?.[handles[key]]?.variants || []).map(variant => variant.options[index]).filter(Boolean))].map(value => ({value, label: value}));
    for (const [kitKey, kit] of Object.entries(kits)) {
      const mapping = {'mount-material':['mount',0], 'mount-colour':['mount',1], 'budget-colour':['budget',0], 'cover-colour':['cover',0], 'dc-cable-length':['dc',0], 'switch-colour':['switch',0]};
      for (const option of kit.options) {
        if (mapping[option.id]) { const [key,index] = mapping[option.id]; const values = optionValues(key,index); option.values = values.map(value => ({...value, label: option.values?.find(old => old.value === value.value)?.label || value.label})); }
        if (option.id === 'cable-length') option.valuesByParent = {anderson:optionValues('anderson',0), vehicle:optionValues('vehicle',0)};
        if (option.id === 'tether-length') option.valuesByParent = {yes:optionValues('tether',0), no:[]};
      }
      const key = kitKey === 'essential' ? 'budget' : 'mount';
      kit.mountImages = Object.fromEntries((products?.[handles[key]]?.variants || []).map(variant => [variant.options[key === 'mount' ? 1 : 0], variant.mediaUrl || products[handles[key]].image]));
    }
    function valuesFor(option, kitKey) { return option.dependsOn ? option.valuesByParent[selections[kitKey][option.dependsOn]] || [] : option.values; }
    function prepareSelections(kitKey) {
      selections[kitKey] ||= {};
      for (const option of kits[kitKey].options) {
        const values = valuesFor(option, kitKey);
        if (!values.some(value => value.value === selections[kitKey][option.id])) selections[kitKey][option.id] = values[0]?.value || '';
      }
    }
    function linesFor(kitKey, selected) {
      const lines = [], add = (key, label, options) => lines.push({handle: handles[key], label: products?.[handles[key]]?.title || label, variant: options ? variantFor(products?.[handles[key]], options) : fixedVariant(products?.[handles[key]])});
      if (kitKey === 'essential') add('budget', 'Budget Starlink Mini Mount', [selected['budget-colour']]); else add('mount', 'Starshield Mount', [selected['mount-material'], selected['mount-colour']]);
      if (kitKey === 'ultimate') {
        add('cover', 'Starshield Armour acrylic cover', [selected['cover-colour']]); add('victron', 'Victron DC power supply');
        add('dc', 'Original Starlink Mini DC power cable', [selected['dc-cable-length']]); add('switch', '12 V/24 V power switch kit', [selected['switch-colour']]);
      } else add(selected['cable-type'], selected['cable-type'] === 'anderson' ? 'Starlink Mini to Anderson cable' : '12–24 V vehicle power cable', [selected['cable-length']]);
      if (kitKey !== 'essential') add('holders', 'Magnetic cable holders');
      if (selected['include-tether'] === 'yes') add('tether', 'Security tether', [selected['tether-length']]);
      return lines;
    }
    function optionPrice(kitKey, option, value) {
      const selected = {...selections[kitKey], [option.id]: value.value};
      const keys = {'mount-material': 'mount', 'budget-colour': 'budget', 'dc-cable-length': 'dc', 'cable-length': selected['cable-type'], 'tether-length': 'tether'};
      return option.id in keys ? linesFor(kitKey, selected).find(line => line.handle === handles[keys[option.id]])?.variant?.price ?? null : null;
    }
  function carouselItemsFor(kitKey, kit, selectedMountColour) {
    const cableType = selections[kitKey]['cable-type'];
    const includeTether = selections[kitKey]['include-tether'] === 'yes';
    const tetherOption = kit.options.find(option => option.id === 'tether-length');
    const tetherLength = valuesFor(tetherOption, kitKey).find(value => value.value === selections[kitKey]['tether-length'])?.label;
    const nativeLines = linesFor(kitKey, selections[kitKey]);
    return kit.carouselItems.filter(item => item.kind !== 'tether' || includeTether).map((item,index) => ({
      label: nativeLines[index]?.label || (item.kind === 'cable' ? (item.labelsByOption?.[cableType] || item.label) : item.kind === 'tether' && tetherLength ? `${item.label} · ${tetherLength}` : item.label),
      image: nativeLines[index]?.variant?.mediaUrl || products?.[nativeLines[index]?.handle]?.image || (item.kind === 'mount'
        ? (kit.mountImages?.[selectedMountColour] || item.image)
        : item.kind === 'cable'
          ? (item.imagesByOption?.[cableType] || item.image)
          : item.image)
    }));
  }

  function renderCarousel(kitKey, kit, selectedMountColour) {
    const carousel = scope.querySelector(`[data-kit-carousel="${kitKey}"]`);
    if (!carousel) return;
    const items = carouselItemsFor(kitKey, kit, selectedMountColour);
    const spread = window.matchMedia('(max-width: 760px)').matches ? 72 : 105;
    const active = ((carouselIndexes[kitKey] || 0) % items.length + items.length) % items.length;
    carouselIndexes[kitKey] = active;
    const track = carousel.querySelector('.kit-coverflow-track');
    const itemNodes = items.map((item, index) => {
      let offset = index - active;
      if (offset > items.length / 2) offset -= items.length;
      if (offset < -items.length / 2) offset += items.length;
      const distance = Math.abs(offset);
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'kit-coverflow-item';
      card.dataset.active = String(index === active);
      card.setAttribute('aria-label', `${item.label}${index === active ? ', selected' : ''}`);
      card.style.setProperty('--flow-x', `${offset * spread}px`);
      card.style.setProperty('--flow-scale', String(Math.max(.48, 1 - distance * .18)));
      card.style.setProperty('--flow-rotate', `${offset * -13}deg`);
      card.style.setProperty('--flow-z', String(20 - distance));
      card.style.setProperty('--flow-opacity', String(Math.max(.3, 1 - distance * .2)));
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      const label = document.createElement('span');
      label.textContent = item.label;
      card.append(image, label);
      card.onclick = event => {
        event.stopPropagation();
        carouselIndexes[kitKey] = index;
        renderCarousel(kitKey, kit, selectedMountColour);
      };
      return card;
    });
    track.replaceChildren(...itemNodes);

    const move = direction => {
      carouselIndexes[kitKey] = (carouselIndexes[kitKey] + direction + items.length) % items.length;
      renderCarousel(kitKey, kit, selectedMountColour);
    };
    carousel.querySelectorAll('[data-carousel-step]').forEach(button => {
      button.onclick = event => {
        event.stopPropagation();
        move(Number(button.dataset.carouselStep));
      };
    });
    carousel.onkeydown = event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    };
    carousel.onwheel = event => {
      if (Math.abs(event.deltaX) + Math.abs(event.deltaY) < 8) return;
      event.preventDefault();
      const now = Date.now();
      if (now - Number(carousel.dataset.lastWheel || 0) < 240) return;
      carousel.dataset.lastWheel = String(now);
      move((event.deltaX || event.deltaY) > 0 ? 1 : -1);
    };
    let swipeStart = null;
    carousel.onpointerdown = event => {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') swipeStart = event.clientX;
    };
    carousel.onpointerup = event => {
      if (swipeStart !== null && Math.abs(event.clientX - swipeStart) > 32) move(event.clientX < swipeStart ? 1 : -1);
      swipeStart = null;
    };
  }



    function renderKit() {
      const kitKey = scope.querySelector('[data-kit-choice]:checked')?.value || initialKit, kit = kits[kitKey]; prepareSelections(kitKey);
      selectedLines = linesFor(kitKey, selections[kitKey]);
      const colour = selections[kitKey]['mount-colour'] || selections[kitKey]['budget-colour'];
      const hero = scope.querySelector(`[data-kit-card="${kitKey}"] .kit-tier-hero`);
      const nativeMount = linesFor(kitKey, selections[kitKey])[0];
      const nativeMountImage = nativeMount?.variant?.mediaUrl || products?.[nativeMount?.handle]?.image;
      if (hero && nativeMountImage) { hero.src = nativeMountImage; hero.alt = `${kit.name} mount in ${colour}`; }
      renderCarousel(kitKey, kit, colour);
      $('kit-name').textContent = kit.name; $('kit-description').textContent = kit.description; $('kit-saving').textContent = `SAVE ${kit.saving}%`;
      const list = names => names.map(name => { const li = document.createElement('li'); li.textContent = name; return li; });
      const component = line => {
        const li = document.createElement('li'), product = products?.[line.handle];
        if (!product?.url) { li.textContent = line.label; return li; }
        const link = document.createElement('a'); link.className = 'kit-component-link';
        const destination = new URL(product.url, window.location.origin); if (line.variant?.id) destination.searchParams.set('variant', line.variant.id);
        link.href = destination; link.textContent = line.label;
        const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = ' →'; link.append(arrow);
        link.addEventListener('click', event => {
          event.preventDefault();
          const token = crypto.randomUUID(), previous = sessionStorage.getItem(kitJourneyActiveKey);
          if (previous && previous !== token) sessionStorage.removeItem(`${kitJourneyPrefix}${previous}`);
          const returnUrl = new URL(window.location.href); returnUrl.searchParams.delete('ss_kit_restore');
          const journey = {version: 1, token, createdAt: Date.now(), returnUrl: returnUrl.toString(), scrollY: window.scrollY, activeKit: kitKey, selections, carouselIndexes, quantities: selectedLines.map(item => ({handle: item.handle, variantId: item.variant?.id || null, quantity: 1}))};
          try { sessionStorage.setItem(`${kitJourneyPrefix}${token}`, JSON.stringify(journey)); sessionStorage.setItem(kitJourneyActiveKey, token); }
          catch (_) { window.location.assign(destination); return; }
          const restoreUrl = new URL(returnUrl); restoreUrl.searchParams.set('ss_kit_restore', token); history.replaceState(history.state, '', restoreUrl);
          destination.searchParams.set('ss_kit_return', token); window.location.assign(destination);
        });
        li.append(link); return li;
      };
      $('kit-components').replaceChildren(...selectedLines.map(component));
      $('kit-fixed').hidden = kit.fixedComponents.length === 0; $('kit-fixed-components').replaceChildren(...list(kit.fixedComponents));
      const activeOption = document.activeElement?.dataset.kitOption, fields = [];
      for (const option of kit.options) {
        const values = valuesFor(option, kitKey); if (option.dependsOn && values.length === 0) continue;
        const field = document.createElement(option.type === 'checkbox' ? 'div' : 'label'); field.className = 'kit-field';
        const label = document.createElement(option.type === 'checkbox' ? 'label' : 'span'); label.textContent = option.label;
        const control = document.createElement(option.type === 'checkbox' ? 'input' : 'select'); control.dataset.kitOption = option.id; control.disabled = busy;
        if (option.type === 'checkbox') {
          field.classList.add('kit-field-checkbox'); control.type = 'checkbox'; control.id = `kit-${kitKey}-${option.id}`; control.checked = selections[kitKey][option.id] === 'yes';
          label.textContent = option.values.find(value => value.value === 'yes')?.label || option.label; label.htmlFor = control.id; control.setAttribute('aria-label', label.textContent); field.append(control, label);
        } else {
          for (const value of values) {
            const choice = document.createElement('option'); choice.value = value.value; const price = optionPrice(kitKey, option, value);
            choice.textContent = value.label + (price === null ? '' : ` · ${money(price)}`); choice.selected = value.value === selections[kitKey][option.id]; control.append(choice);
          }
          field.append(label, control);
        }
        control.addEventListener('change', () => { selections[kitKey][option.id] = option.type === 'checkbox' ? (control.checked ? 'yes' : 'no') : control.value; renderKit(); }); fields.push(field);
      }
      $('kit-options').replaceChildren(...fields);
      if (activeOption) $('kit-options').querySelector(`[data-kit-option="${activeOption}"]`)?.focus({preventScroll: true});
      const unavailable = selectedLines.filter(line => !line.variant?.available || !quantityAllowed(line.variant, 1));
      const total = selectedLines.reduce((sum, line) => sum + (line.variant?.price || 0), 0), kitTotal = Math.round(total * (100 - kit.saving) / 100);
      $('kit-original-price').textContent = unavailable.length ? '—' : money(total); $('kit-price').textContent = unavailable.length ? 'Unavailable' : money(kitTotal);
      $('kit-save-amount').textContent = unavailable.length ? '' : `Estimated saving ${money(total - kitTotal)}`;
      $('kit-add').disabled = busy || unavailable.length > 0; $('kit-add').textContent = busy ? 'Adding…' : 'Add complete kit';
      $('kit-status').textContent = busy ? 'Adding your kit…' : unavailable.length ? `${unavailable.map(line => line.label).join(', ')} unavailable in this configuration. Please choose another option.` : '';
      scope.querySelectorAll('[data-kit-choice]').forEach(choice => { choice.disabled = busy; });
    }
    scope.querySelectorAll('[data-kit-choice]').forEach(choice => choice.addEventListener('change', renderKit));
    $('kit-add').addEventListener('click', async () => {
      if (busy || $('kit-add').disabled) return;
      const kitKey = scope.querySelector('[data-kit-choice]:checked').value, bundle = crypto.randomUUID();
      const items = selectedLines.map(line => ({id: line.variant.id, quantity: 1, properties: {Kit: kits[kitKey].name, _starshield_kit: kitKey, _starshield_bundle: bundle}}));
      busy = true; renderKit();
      try { await addItems(items); } catch (error) { busy = false; renderKit(); $('kit-status').textContent = error.message; }
    });
    const initialChoice = scope.querySelector(`[data-kit-choice][value="${restoredKit || initialKit}"]`); if (initialChoice) initialChoice.checked = true;
    Object.keys(kits).forEach(prepareSelections); renderKit();
    if (restoredScroll !== null) requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo({top: restoredScroll, behavior: 'auto'})));
    window.addEventListener('resize', () => { const key = scope.querySelector('[data-kit-choice]:checked')?.value || initialKit; renderCarousel(key, kits[key], selections[key]['mount-colour'] || selections[key]['budget-colour']); });
  }

  function initCatalog(catalog) {
    if (initialised.has(catalog)) return;
    initialised.add(catalog);
    const scope = catalog.closest('.shopify-section') || catalog.parentElement;
    const filter = scope.querySelector('[data-catalog-filter]'), sort = scope.querySelector('[data-catalog-sort]'), count = scope.querySelector('[data-result-count]'), empty = scope.querySelector('[data-no-results]');
    const cards = [...catalog.children];
    const update = () => {
      const query = (filter?.value || '').trim().toLowerCase(), ordered = [...cards];
      if (sort?.value === 'price-up') ordered.sort((a,b) => +a.dataset.price - +b.dataset.price);
      if (sort?.value === 'price-down') ordered.sort((a,b) => +b.dataset.price - +a.dataset.price);
      if (sort?.value === 'name') ordered.sort((a,b) => a.dataset.name.localeCompare(b.dataset.name));
      let shown = 0; ordered.forEach(card => { card.hidden = !card.dataset.name.includes(query); if (!card.hidden) shown++; catalog.append(card); });
      if (count) count.textContent = `${shown} product${shown === 1 ? '' : 's'}`; if (empty) empty.hidden = shown !== 0;
    };
    filter?.addEventListener('input', update); sort?.addEventListener('change', update);
  }
  function init(scope) {
    scope.querySelectorAll('[data-product-root]').forEach(initProduct); scope.querySelectorAll('#kit-data').forEach(initKit); scope.querySelectorAll('[data-catalog]').forEach(initCatalog);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
